





























































import theme from '@zk/theme/lib/variables.scss';
import { defineComponent, computed, toRef, provide, reactive, watch } from '@vue/composition-api';

import DrawerHead from './DrawerHead.vue';
import DrawerFooter from './DrawerFooter.vue';
import TheRightArea from '../components/TheRightArea.vue';
import TheLeftArea from '../components/TheLeftArea.vue';
import TheFieldListArea from '../components/TheFieldListArea.vue';
import CustomFieldDialog from 'common-module/src/components/CustomFieldDialog';
import CustomFieldOverTipsDialog from 'common-module/src/components/Subscription/CustomFieldOverTipsDialog';

import { useFieldLayout } from '../store';
import { AREA_CODE_MAP } from '../store/layouts';
import { newDataToUsedField } from '../store/transformData.ts';
import { AddFieldResult, AddFieldReturnData, FieldTypeModel } from '../model/field';
import { PLACABLE_FIELDS_LEFT } from '../common/config';
import { LayoutFieldItem, AreaCodeModel } from '../model/layout';
import { useInstance } from 'common-module/src/util/useInstance';
import { resolveUrl, addUrlParams } from '@zk/framework-vue';
import { useDebounceFn } from '@vueuse/core';

export default defineComponent({
  name: 'LayoutDrawerContent',
  components: {
    DrawerHead,
    DrawerFooter,
    TheRightArea,
    TheLeftArea,
    TheFieldListArea,
    CustomFieldDialog,
    CustomFieldOverTipsDialog
  },
  props: {},
  setup() {
    const instance = useInstance();
    const store = useFieldLayout();
    const action = toRef(store, 'action');

    // 使用computed属性来创建一个响应式的allFields计算值
    const usedFields = computed(() => [
      ...store.leftAreaFields,
      ...store.rightAreaFields
    ]);
    // 创建一个响应式对象并包含allFields计算属性
    const fieldConfig = reactive({
      get usedFields() {
        return usedFields.value;
      }
    });
    // 将fieldConfig提供给组件树
    provide('fieldConfig', fieldConfig);

    // 创建字段
    const onCreateField = () => store.openFieldDialog('add');

    // 编辑字段
    const onEditField = (fieldInfo: LayoutFieldItem, areaCode: AreaCodeModel) => {
      console.log('onEditField:', fieldInfo);
      store.openFieldDialog('edit', fieldInfo, areaCode);
    };

    // 跳转查看组织字段
    const onJumpViewField = (fieldInfo: LayoutFieldItem) => {
      const { customFieldName, customFieldId } = fieldInfo || {};
      const url = resolveUrl(`${instance.$config.VUE_APP_PMS_URL}/setting/fields`);
      window.open(addUrlParams(url, { customFieldName, customFieldId }), '_blank');
    };

    // 已存在的字段名称
    const existNames = computed(() => store.fieldCollection?.map(field => field.customFieldName) || []);
    const isEdit = computed(() => store.fieldDialogStatus === 'edit');

    const bindCustomField = computed(() => ({
      id: store.currentEditField?.customFieldId,
      existNames: existNames.value,
      // isView: isView.value,
      currentProjectId: action.value?.projectId,
      showExpressionTips: false
    }));

    /**
     * 新增/编辑字段保存
     * @param resVal 新增后服务器返回信息
     * @param data 字段数据
     * @param fieldType
     * @returns {Promise<void>}
    */
    const onSaveField = (
      resVal: AddFieldResult,
      data: AddFieldReturnData,
      fieldType: FieldTypeModel
    ) => {
      if ((typeof resVal === 'boolean' && resVal) || isEdit.value) {
        // 编辑字段
        if (!store.currentEditArea || !store.currentEditField) {
          return;
        }
        store.updateFieldInLayout(
          {
            customFieldId: store.currentEditField.customFieldId,
            customFieldName: data.fieldName,
            tips: data.tips
          },
          toRef(store, AREA_CODE_MAP[store.currentEditArea])
        );
        return;
      }

      // 新增字段
      const newField = newDataToUsedField({
        ...fieldType,
        ...resVal,
        customFieldId: resVal.id,
        customFieldName: data.fieldName,
        fieldCode: data.fieldCode,
        fieldProjectId: action.value?.projectId || 0,
        issueTypeId: action.value?.issueType?.id || 0,
        tips: data.tips
      });

      const insertArea = PLACABLE_FIELDS_LEFT.includes(newField.controlCode)
        ? toRef(store, 'leftAreaFields')
        : toRef(store, 'rightAreaFields');
      store.fieldInsertLayout(
        newField,
        insertArea
      );

      // 滚动到底部
      const scrollContainer = PLACABLE_FIELDS_LEFT.includes(newField.controlCode)
        ? instance.$el.querySelector('[data-area-code="left"]')
        : instance.$el.querySelector('[data-area-code="right"]');
      setTimeout(() => scrollContainer?.scrollBy(0, scrollContainer.scrollHeight), 200);
    };

    /**
     * 保存布局
     */
    const onSaveLayout = () => {
      // 公式字段校验
      if (!store.checkFormulaDepend) {
        const customFieldName = store.lackOfDependency.map(f => f.customFieldName);
        const formulaName = (store.unusedDependFields || []).map(f => f.customFieldName);
        const msg = 'project.issueType.layout.removeRequired.saveMsg';

        formulaCheckMsgBox(
          customFieldName.join(','),
          formulaName.join(','),
          msg
        );
        return;
      }
      store.onSave();
    };
    // 公式字段校验提示
    const formulaCheckMsgBox = (
      customFieldName: string,
      formulaName: string,
      msgName: string
    ) => {
      const msg = instance.$t(msgName, [customFieldName, formulaName]);
      const title = instance.$t('project.issueType.layout.removeRequired.title');
      const btn = instance.$t('project.issueType.layout.removeRequired.btn');

      instance.$alert(msg, title, {
        confirmButtonText: btn,
        dangerouslyUseHTMLString: true,
        closeOnPressEscape: true
      }).catch(() => {});
    };

    return {
      bindCustomField,
      fieldDialogVisible: toRef(store, 'showFieldDialog'),
      fieldOverVisible: toRef(store, 'fieldRightVisible'),
      onCreateField,
      onEditField,
      onJumpViewField,
      onSaveField,
      onCancelField: toRef(store, 'closeFieldDialog'),
      onSaveLayout,
      onClose: useDebounceFn(store.closeDrawer, 200)
    };
  },
  data() {
    return {
      bemNS: theme.bemNS
    };
  }
});
